export const createUpdateBookingUIKey = bookingID => `UPDATE_BOOKING_${bookingID}`;
